const dtf = (opts) => new Intl.DateTimeFormat('fr-FR', opts);

const timeFmt = dtf({ hour: '2-digit', minute: '2-digit' });
const dayFmt = dtf({ weekday: 'long', day: 'numeric', month: 'long' });
const shortDayFmt = dtf({ weekday: 'short', day: 'numeric', month: 'short' });
const fullFmt = dtf({ weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' });

export const formatTime = (iso) => (iso ? timeFmt.format(new Date(iso)) : '');
export const formatDay = (iso) => (iso ? dayFmt.format(new Date(iso)) : '');
export const formatShortDay = (iso) => (iso ? shortDayFmt.format(new Date(iso)) : '');
export const formatFull = (iso) => (iso ? fullFmt.format(new Date(iso)) : '');

export function formatDistance(metres) {
  if (metres == null) return '';
  return metres < 1000 ? `${Math.round(metres)} m` : `${(metres / 1000).toFixed(metres < 10000 ? 1 : 0)} km`;
}

export function formatDuration(seconds) {
  if (seconds == null) return '';
  const mins = Math.round(seconds / 60);
  if (mins < 60) return `${mins} min`;
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return m === 0 ? `${h} h` : `${h} h ${String(m).padStart(2, '0')}`;
}

/** Relative day label, e.g. "dans 3 jours" / "aujourd'hui". */
export function relativeDay(iso) {
  if (!iso) return '';
  const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const days = Math.round((startOfDay(new Date(iso)) - startOfDay(new Date())) / 86_400_000);
  if (days === 0) return "aujourd'hui";
  if (days === 1) return 'demain';
  if (days === -1) return 'hier';
  if (days > 1) return `dans ${days} jours`;
  return `il y a ${Math.abs(days)} jours`;
}

/** ISO -> value for <input type="datetime-local">, in the viewer's own timezone. */
export function toLocalInput(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Date(d.getTime() - d.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);
}

export const fromLocalInput = (value) => (value ? new Date(value).toISOString() : null);

export function initials(name) {
  const parts = String(name || '?').trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0] ?? '').join('').toUpperCase() || '?';
}

/**
 * Nominatim returns the full administrative chain ("Jean Mace, Avenue Jean
 * Jaures, Les Girondins, Lyon 7e Arrondissement, Lyon, Metropole de Lyon,
 * Rhone, ...""). Keep the part a human needs to recognise the spot.
 */
export function shortAddress(address, label) {
  if (!address) return '';
  const parts = address.split(',').map((p) => p.trim()).filter(Boolean);
  if (label && parts[0] === String(label).trim()) parts.shift();
  return parts.slice(0, 3).join(', ');
}
